import { render, staticRenderFns } from "./TipsNotice.vue?vue&type=template&id=271becde&scoped=true"
import script from "./TipsNotice.vue?vue&type=script&lang=js"
export * from "./TipsNotice.vue?vue&type=script&lang=js"
import style0 from "./TipsNotice.vue?vue&type=style&index=0&id=271becde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271becde",
  null
  
)

export default component.exports